import FacebookTwoToneIcon from "@mui/icons-material/FacebookTwoTone";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InstagramIcon from "@mui/icons-material/Instagram";
import PinterestIcon from "@mui/icons-material/Pinterest";
import TwitterIcon from "@mui/icons-material/Twitter";
import PlaceIcon from "@mui/icons-material/Place";
import LanguageIcon from "@mui/icons-material/Language";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import ActionButtons from "./ActionButtons";
import UnfriendModal from "./UnfriendModal";
import { useNavigate } from "react-router-dom";
import { makeRequest } from "../../../utils/axios.js"; 
import { useChatDatabase } from "../../../lib/chatDatabase";
import { useState } from "react";
import { useWallet } from "../hooks/useWallet.js";

const ProfileHeader = ({ user, logic, setOpenUpdate }) => {
    const navigate = useNavigate();
    const { selectChat, startNewChat } = useChatDatabase();

    const [isUnfriendModalOpen, setIsUnfriendModalOpen] = useState(false);

    const { account, isConnecting, connectWallet, formatAddress } = useWallet();
    
    const getSrc = (path) => path?.startsWith("http") 
                            ? path 
                            : (path || "/public/noAvatar.png");

    const getSrcCover = (path) => path?.startsWith("http") 
                            ? path 
                            : (path || "/public/noCover.png");                        

    const handleSendMessage = async(e) => {
        e.preventDefault();
        e.stopPropagation();

        if (logic.isOwnProfile) return;

        try {
            const res = await makeRequest.get(`/chats/find?receiverId=${user.id}`);
            
            if (res.data.chatId) {
                await selectChat({
                    chatId: res.data.chatId,
                    receiverId: user.id,
                    receiverName: user.name,
                    receiverProfilePic: user.profilePic,
                    isSeen: true 
                });
            } else {
                startNewChat(user);
            }
            navigate(`/chat/${user.id}`);
        } catch (err) {
            console.log("Error when opening chat:", err);
        }
    };

    const handleFriendButtonClick = () => {
        if (logic.friendship.status === "friends") {
            setIsUnfriendModalOpen(true);
        } else {
            logic.actions.handleFriendAction();
        }
    };

    const handleConfirmUnfriend = () => {
        logic.actions.handleFriendAction(); 
        setIsUnfriendModalOpen(false);    
    };

    return (
        <>
            <div className="images">
                <img src={getSrcCover(user.coverPic)} alt="" className="cover" />
                
                <img src={getSrc(user.profilePic)} alt="" className="profilePic" />
            </div>

            <div className="profileContainer">
                <div className="uInfo">
                    <div className="left">
                        <a href="http://facebook.com"><FacebookTwoToneIcon fontSize="large" /></a>
                        <a href="http://instagram.com"><InstagramIcon fontSize="large" /></a>
                        <a href="http://twitter.com"><TwitterIcon fontSize="large" /></a>
                        <a href="http://linkedin.com"><LinkedInIcon fontSize="large" /></a>
                        <a href="http://pinterest.com"><PinterestIcon fontSize="large" /></a>
                    </div>

                    <div className="center">
                        <h1 className="name">
                            {user.name}
                        </h1>
                        
                        <div className="info">
                            <div className="item">
                                <PlaceIcon /> 

                                <span>
                                    {user.city}
                                </span>
                            </div>

                            <div className="item">
                                <LanguageIcon /> 

                                <span>
                                    {user.website}
                                </span>
                            </div>

                            <div className="item wallet-info">
                                <AccountBalanceWalletIcon className="wallet-icon" /> 
                                
                                {logic.isOwnProfile ? (
                                    account ? (
                                        <span className="connected-text">
                                            Đã kết nối: {formatAddress(account)}
                                        </span>
                                    ) : (
                                        <button 
                                            className="btn-connect-wallet"
                                            onClick={connectWallet}
                                            disabled={isConnecting}
                                        >
                                            {isConnecting ? "Đang kết nối..." : "Kết nối MetaMask"}
                                        </button>
                                    )
                                ) : (
                                    <span className="unconnected-text">
                                        {user.walletAddress ? formatAddress(user.walletAddress) : "Chưa liên kết ví"}
                                    </span>
                                )}
                            </div>
                        </div>

                        <div className="actionButtons">
                            <ActionButtons 
                                isOwnProfile={logic.isOwnProfile}
                                onUpdateClick={() => setOpenUpdate(true)}
                                onFollow={logic.actions.handleFollow}
                                onFriendAction={handleFriendButtonClick}
                                isFollowing={logic.relationship.isFollowing}
                                friendStatus={logic.friendship.status}
                                rLoading={logic.relationship.isLoading}
                                fLoading={logic.friendship.isLoading}
                            />
                        </div>
                    </div>

                    <div className="right">
                        <div 
                            onClick={handleSendMessage} 
                            style={{ cursor: logic.isOwnProfile ? "default" : "pointer" }}
                        >
                            <EmailOutlinedIcon />
                        </div>

                        <MoreVertIcon />
                    </div>
                </div>
            </div>

            <UnfriendModal 
                isOpen={isUnfriendModalOpen}
                onConfirm={handleConfirmUnfriend}
                onCancel={() => setIsUnfriendModalOpen(false)}
            />
        </>
    );
};

export default ProfileHeader;